<template>
  <div>
  <v-card 
    class="mx-auto"
    max-width="344"
  >
    <v-card-text v-if="!loading">
      <v-text-field
        v-model="station.id"
        label="Χαρακτηριστικό (id)"
        disabled
      ></v-text-field>

      <v-text-field
        v-model="station.authKey"
        disabled
        label="Κλειδί (auth key)"
      ></v-text-field>

      <v-text-field
        v-model="station.description"
        label="Περιγραφή"
        :disabled="!canEdit"
      ></v-text-field>

      <v-text-field
        type="number"
        v-model.number="station.latitude"
        :disabled="!canEdit"
        label="Γεωγραφικό Πλάτος (Latitude)"
      ></v-text-field>

      <v-text-field
        type="number"
        v-model.number="station.longitude"
        :disabled="!canEdit"
        label="Γεωγραφικό Μήκος (Longitude)"
      ></v-text-field>

      <CampPicker :camps="camps" :disabled="!canEdit" :limit="1" ref="campPicker"/>

    </v-card-text>

    <v-spacer></v-spacer>

    <p class="font-weight-regular" style="color: red;">
      {{ error }}
    </p>

    <v-card-actions>
          <v-btn
            color="blue"
            :disabled="!canEdit"
            :loading="loading"
            @click="save"
          >ΑΠΟΘΗΚΕΥΣΗ ΑΛΛΑΓΩΝ</v-btn>


          <v-dialog
            v-model="dialog"
            width="500"
          >
            <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!canEdit"
              :loading="loading"
              v-bind="attrs"
              v-on="on"
              color="red"
              class="ml-2"
            >ΔΙΑΓΡΑΦΗ</v-btn>
            </template>

            <v-card>
              <v-card-title>
                Επιβεβαίωση
              </v-card-title>

              <v-card-text>
                  Είστε σίγουρος πως θέλετε να διαγράψετε τον αισθητήρα;
                  Αυτή η ενέργεια είναι μη αντιστρέψιμη.
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red"
                  @click="deleteStation"
                >
                  Ναι, ΔΙΑΓΡΑΦΗ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
    </v-card-actions>
  </v-card>

  <div v-if="this.stationId">
    <v-divider class="mt-2 mb-2"></v-divider>
    <WeatherUpdateManagement :stationIdFilter="stationId" :hideToolbar="true"/>
  </div>
  </div>
</template>

<script>
import WeatherUpdateManagement from '@/views/WeatherUpdateManagement.vue'
import CampPicker from '@/components/CampPicker.vue'

export default {
  name: 'StationDetails',
  props: {
    stationId: {
      type: String,
      default: undefined,
      required: false
    },
    createNew: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    WeatherUpdateManagement,
    CampPicker
  },
  data: () => {
      return {
          loading: true,
          station: {
              id: "",
              authKey: "",
              description: "",
              latitude: "",
              longitude: ""
          },
          camps: [],
          error: "",
          dialog: false
      }
  },
  async mounted() {
    if (this.createNew) {
      this.loading = false
      return
    }
    await this.load()
  },
  watch: {
    stationId: {
      handler: async function() {
        await this.load()
      }
    }
  },
  computed: {
        canEdit() {
          return this.$store.state.user.isAdmin
        }
    },
    methods: {
        async deleteStation() {
            this.loading = true
            try {
                const response = await this.$axios.delete('/weatherStations', { params: { id: this.stationId } })
                console.log(response)
                this.error = `Successfully Deleted weather station ${this.stationId}`
                // this.$router.replace('/sensors')
            } catch (e) {
                console.log(e)
                this.error = e.response.data
            }
            this.loading = false
            this.dialog = false
        },
        async load(){
            this.loading = true
            try {
                const response = await this.$axios.get('/weatherStations', { params: { id: this.stationId } })
                this.station = Object.assign({}, this.station, response.data)
                this.camps = [response.data.campName]

                this.error = ""
            } catch (e) {
                console.log(e.response.data)
                this.error = e.response.data
            }
            this.loading = false
        },
        async save() {
          const payload = {
              description: this.station.description,
              latitude: this.station.latitude,
              longitude: this.station.longitude,
              campName: this.$refs.campPicker.selectedCamps[0]
          }
          console.log(this.camps)
          console.log(payload)

          if (!this.createNew) {
            payload['id'] = this.station.id
          }

          // console.log(payload)
          try {
            const response = await this.$axios.put('/weatherStations/', payload)
            if (this.createNew) {
              this.stationId = response.data
            }
          } catch (e) {
              console.log(e.response.data)
              this.error = e.response.data
              return
          }
          await this.load()
        }
    }
}
</script>
